import { InsightsNavbar } from "@/components/InsightsNavbar";
import { AnimatedSection } from "@/components/AnimatedSection";
import { ScrollProgressIndicator } from "@/components/ScrollProgressIndicator";
import { Footer } from "@/components/Footer";
import { InsightsBreadcrumb } from "@/components/InsightsBreadcrumb";
import { GmailPromotionsHeroSection } from "@/components/insights/gmail-promotions/GmailPromotionsHeroSection";
import { GmailPromotionsTakeaway } from "@/components/insights/gmail-promotions/GmailPromotionsTakeaway";
import { GmailPromotionsFounderQuote } from "@/components/insights/gmail-promotions/GmailPromotionsFounderQuote";
import { GmailPromotionsKeyFindings } from "@/components/insights/gmail-promotions/GmailPromotionsKeyFindings";
import { GmailPromotionsFactors } from "@/components/insights/gmail-promotions/GmailPromotionsFactors";
import { GmailPromotionsStrategies } from "@/components/insights/gmail-promotions/GmailPromotionsStrategies";
import { GmailPromotionsAnalyzer } from "@/components/insights/gmail-promotions/GmailPromotionsAnalyzer";
import { GmailPromotionsSources } from "@/components/insights/gmail-promotions/GmailPromotionsSources";
import { InsightsLeadModal } from "@/components/InsightsLeadModal";
import { InsightSEO } from "@/hooks/useInsightSEO";
import { RelatedTools } from "@/components/RelatedTools";
import { InsightEngagementTracker } from "@/components/InsightEngagementTracker";
import { InsightFAQSection } from "@/components/InsightFAQSection";
import { InsightBenchmarks } from "@/components/InsightBenchmarks";
import { TableOfContents } from "@/components/TableOfContents";

const GmailPromotionsTab = () => {
  return (
    <>
      <InsightSEO 
        slug="gmail-promotions-tab" 
        additionalKeywords={["Gmail primary tab", "Gmail categories", "email marketing", "inbox placement", "email categorization"]}
      />
      <InsightEngagementTracker slug="gmail-promotions-tab" title="Gmail Promotions Tab" />
      <InsightsNavbar showBack />
      <ScrollProgressIndicator />
      <TableOfContents />
      <InsightsLeadModal />
      <main className="page-container pb-16 sm:pb-20">
        <InsightsBreadcrumb 
          category="Gmail" 
          currentPage="Promotions Tab Algorithm" 
        />
        <GmailPromotionsHeroSection />
        
        <AnimatedSection delay={100} className="mt-10 sm:mt-12">
          <GmailPromotionsTakeaway />
        </AnimatedSection>

        <AnimatedSection delay={50} className="mt-8 sm:mt-10">
          <GmailPromotionsFounderQuote />
        </AnimatedSection>

        <div className="section-divider" />

        <AnimatedSection delay={0}>
          <GmailPromotionsKeyFindings />
        </AnimatedSection>
        
        <AnimatedSection delay={0}>
          <GmailPromotionsFactors />
        </AnimatedSection>
        
        <AnimatedSection delay={0}>
          <GmailPromotionsAnalyzer />
        </AnimatedSection>
        
        <AnimatedSection delay={0}>
          <GmailPromotionsStrategies />
        </AnimatedSection>
        
        <AnimatedSection delay={0}>
          <GmailPromotionsSources />
        </AnimatedSection>
        
        {/* Benchmark Tables */}
        <AnimatedSection delay={0}>
          <InsightBenchmarks insightSlug="gmail-promotions-tab" />
        </AnimatedSection>
        
        {/* FAQ Section */}
        <AnimatedSection delay={0}>
          <InsightFAQSection insightSlug="gmail-promotions-tab" />
        </AnimatedSection>
        
        {/* Related Tools Section */}
        <AnimatedSection delay={0}>
          <RelatedTools insightSlug="gmail-promotions-tab" />
        </AnimatedSection>
      </main>
      <Footer />
    </>
  );
};

export default GmailPromotionsTab;
